import React from "react";
import BannerQueuePage from "features/MarketingBanner/presentation/pages/BannerQueue";

function BannerQueueScreen() {
  return <BannerQueuePage />;
}

export default BannerQueueScreen;
